export default __webpack_public_path__ + "static/media/escape-game.a7867789.jpg";